import { EventScreenAction } from '../sharedActions';

// Stage-specific actions for QR Code
export const QR_CODE_FOREGROUND_COLOR_CHANGED =
  'QR_CODE_FOREGROUND_COLOR_CHANGED';
interface ChangeQRCodeForegroundColorAction {
  type: typeof QR_CODE_FOREGROUND_COLOR_CHANGED;
  payload: {
    qrForegroundColor: string;
  };
}
export const changeQRCodeForegroundColor = (
  payload: ChangeQRCodeForegroundColorAction['payload'],
): ChangeQRCodeForegroundColorAction => ({
  type: QR_CODE_FOREGROUND_COLOR_CHANGED,
  payload,
});

export const QR_CODE_BACKGROUND_COLOR_CHANGED =
  'QR_CODE_BACKGROUND_COLOR_CHANGED';
interface ChangeQRCodeBackgroundColorAction {
  type: typeof QR_CODE_BACKGROUND_COLOR_CHANGED;
  payload: {
    qrBackgroundColor: string;
  };
}
export const changeQRCodeBackgroundColor = (
  payload: ChangeQRCodeBackgroundColorAction['payload'],
): ChangeQRCodeBackgroundColorAction => ({
  type: QR_CODE_BACKGROUND_COLOR_CHANGED,
  payload,
});

export const QR_CODE_WRAPPER_BACKGROUND_COLOR_CHANGED =
  'QR_CODE_WRAPPER_BACKGROUND_COLOR_CHANGED';
interface ChangeQRCodeWrapperBackgroundColorAction {
  type: typeof QR_CODE_WRAPPER_BACKGROUND_COLOR_CHANGED;
  payload: {
    qrWrapperBackgroundColor: string;
  };
}
export const changeQRCodeWrapperBackgroundColor = (
  payload: ChangeQRCodeWrapperBackgroundColorAction['payload'],
): ChangeQRCodeWrapperBackgroundColorAction => ({
  type: QR_CODE_WRAPPER_BACKGROUND_COLOR_CHANGED,
  payload,
});

// Context-specific element actions
export const ADD_STAGE_TEXT_ELEMENT = 'ADD_STAGE_TEXT_ELEMENT';
export interface AddStageTextElementAction {
  type: typeof ADD_STAGE_TEXT_ELEMENT;
  payload: {
    element: any; // ScreenElementFragment
  };
}
export const addStageTextElement = (
  payload: AddStageTextElementAction['payload'],
): AddStageTextElementAction => ({
  type: ADD_STAGE_TEXT_ELEMENT,
  payload,
});

export const ADD_FAN_TEXT_ELEMENT = 'ADD_FAN_TEXT_ELEMENT';
export interface AddFanTextElementAction {
  type: typeof ADD_FAN_TEXT_ELEMENT;
  payload: {
    element: any; // ScreenElementFragment
  };
}
export const addFanTextElement = (
  payload: AddFanTextElementAction['payload'],
): AddFanTextElementAction => ({
  type: ADD_FAN_TEXT_ELEMENT,
  payload,
});

export const ADD_STAGE_IMAGE_ELEMENT = 'ADD_STAGE_IMAGE_ELEMENT';
export interface AddStageImageElementAction {
  type: typeof ADD_STAGE_IMAGE_ELEMENT;
  payload: {
    element: any; // ScreenElementFragment
  };
}
export const addStageImageElement = (
  payload: AddStageImageElementAction['payload'],
): AddStageImageElementAction => ({
  type: ADD_STAGE_IMAGE_ELEMENT,
  payload,
});

export const ADD_FAN_IMAGE_ELEMENT = 'ADD_FAN_IMAGE_ELEMENT';
export interface AddFanImageElementAction {
  type: typeof ADD_FAN_IMAGE_ELEMENT;
  payload: {
    element: any; // ScreenElementFragment
  };
}
export const addFanImageElement = (
  payload: AddFanImageElementAction['payload'],
): AddFanImageElementAction => ({
  type: ADD_FAN_IMAGE_ELEMENT,
  payload,
});

// Background actions
export const SET_STAGE_BACKGROUND_PREVIEW = 'SET_STAGE_BACKGROUND_PREVIEW';
export interface SetStageBackgroundPreviewAction {
  type: typeof SET_STAGE_BACKGROUND_PREVIEW;
  payload: {
    backgroundImage: string | null;
  };
}
export const setStageBackgroundPreview = (
  payload: SetStageBackgroundPreviewAction['payload'],
): SetStageBackgroundPreviewAction => ({
  type: SET_STAGE_BACKGROUND_PREVIEW,
  payload,
});

export const SET_FAN_BACKGROUND_PREVIEW = 'SET_FAN_BACKGROUND_PREVIEW';
export interface SetFanBackgroundPreviewAction {
  type: typeof SET_FAN_BACKGROUND_PREVIEW;
  payload: {
    backgroundImage: string | null;
  };
}
export const setFanBackgroundPreview = (
  payload: SetFanBackgroundPreviewAction['payload'],
): SetFanBackgroundPreviewAction => ({
  type: SET_FAN_BACKGROUND_PREVIEW,
  payload,
});

export const SAVE_STAGE_BACKGROUND_IMAGE = 'SAVE_STAGE_BACKGROUND_IMAGE';
export interface SaveStageBackgroundImageAction {
  type: typeof SAVE_STAGE_BACKGROUND_IMAGE;
  payload: {
    backgroundImage: string | null;
  };
}
export const saveStageBackgroundImage = (
  payload: SaveStageBackgroundImageAction['payload'],
): SaveStageBackgroundImageAction => ({
  type: SAVE_STAGE_BACKGROUND_IMAGE,
  payload,
});

export const SAVE_FAN_BACKGROUND_IMAGE = 'SAVE_FAN_BACKGROUND_IMAGE';
export interface SaveFanBackgroundImageAction {
  type: typeof SAVE_FAN_BACKGROUND_IMAGE;
  payload: {
    backgroundImage: string | null;
  };
}
export const saveFanBackgroundImage = (
  payload: SaveFanBackgroundImageAction['payload'],
): SaveFanBackgroundImageAction => ({
  type: SAVE_FAN_BACKGROUND_IMAGE,
  payload,
});

// Font actions
export const HEADING_FONT_CHANGED = 'HEADING_FONT_CHANGED';
export interface ChangeHeadingFontAction {
  type: typeof HEADING_FONT_CHANGED;
  payload: {
    fontFamily: string[] | null | undefined;
  };
}
export const changeHeadingFont = (
  payload: ChangeHeadingFontAction['payload'],
): ChangeHeadingFontAction => ({
  type: HEADING_FONT_CHANGED,
  payload,
});

export const BODY_FONT_CHANGED = 'BODY_FONT_CHANGED';
export interface ChangeBodyFontAction {
  type: typeof BODY_FONT_CHANGED;
  payload: {
    fontFamily: string[] | null | undefined;
  };
}
export const changeBodyFont = (
  payload: ChangeBodyFontAction['payload'],
): ChangeBodyFontAction => ({
  type: BODY_FONT_CHANGED,
  payload,
});

// Combined action type
export type ActionType =
  | EventScreenAction // Import shared actions
  | ChangeQRCodeForegroundColorAction
  | ChangeQRCodeBackgroundColorAction
  | ChangeQRCodeWrapperBackgroundColorAction
  | AddStageTextElementAction
  | AddFanTextElementAction
  | AddStageImageElementAction
  | AddFanImageElementAction
  | SetStageBackgroundPreviewAction
  | SetFanBackgroundPreviewAction
  | SaveStageBackgroundImageAction
  | SaveFanBackgroundImageAction
  | ChangeHeadingFontAction
  | ChangeBodyFontAction;
